import { prices } from '../../constants/prices';
import { Course } from '../interfaces/course';
import { CourseStatus } from '../interfaces/course-status';

export const allCourses: Course[] = [
  {
    iconUrl: '/images/tech-icons/ai-chip-white.svg',
    iconAlt: 'Ícone Processador de IA',
    gradientClass: 'from-emerald-500/25 via-blue-500/20 to-[#161E2E]',
    glowColor: 'rgba(16,185,129,0.3)',
    badgeClass: 'badge-warning badge-outline',
    badgeText: 'Pré-venda',
    title: 'Spec-Driven Development',
    description:
      'Curso em pré-venda, ainda em produção, com aulas liberadas progressivamente. Aprenda Spec-Driven Development com OpenSpec e agentes de IA em uma aplicação Angular real com Supabase.',
    url: '/cursos/spec-driven-development',
    level: 'advanced',
    price: prices.specDriven.subscription.totalValue,
    status: CourseStatus.WaitingList,
    releaseDate: new Date(2026, 9, 5),
  },
  {
    iconUrl: '/images/tech-icons/angular-white.svg',
    iconAlt: 'Ícone Angular',
    gradientClass: 'from-[#DD0031]/25 via-[#6657EC]/20 to-[#161E2E]',
    glowColor: 'rgba(102,87,236,0.3)',
    title: 'SSR e SSG com Angular',
    description: '',
    url: '/cursos/ssr-ssg-com-angular',
    level: 'advanced',
    price: prices.ssrSsgComAngular.subscription.totalValue,
    status: CourseStatus.Planning,
    releaseDate: new Date(2026, 9, 1),
  },
  // {
  //   iconUrl: '/images/tech-icons/ai-chip-white.svg',
  //   iconAlt: 'Ícone Processador de IA',
  //   gradientClass: 'from-indigo-600/30 via-emerald-500/20 to-[#161E2E]',
  //   glowColor: 'rgba(0,185,92,0.3)',
  //   title: 'Desenvolvimento com IA',
  //   description:
  //     'Domine a criação de aplicações usando IA em todo o fluxo de desenvolvimento, usando Angular, Antigravity, SSD com OpenSpec e muito mais.',
  //   url: '/cursos/desenvolvimento-com-ia',
  //   level: 'advanced',
  //   price: 0,
  //   status: CourseStatus.WaitingList,
  //   releaseDate: new Date(2026, 7, 1),
  // },
  {
    iconUrl: '/images/tech-icons/ai-chip-white.svg',
    iconAlt: 'Ícone Processador de IA',
    gradientClass: 'from-indigo-600/30 via-blue-500/20 to-emerald-500/10',
    glowColor: 'rgba(49,134,255,0.3)',
    title: 'Dominando Agentes de IA',
    description:
      'Aprenda a construir e orquestrar agentes autônomos de IA integrados com Google Antigravity, Skills personalizadas e servidores MCP.',
    url: '/cursos/dominando-agentes-de-ia',
    level: 'intermediate',
    price: prices.dominandoAgentesDeIa.subscription.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2026, 7, 1),
  },
  {
    iconUrl: '/images/tech-icons/form-white.svg',
    iconAlt: 'Ícone Formulários',
    gradientClass: 'from-[#6657EC]/30 via-[#E30A7B]/20 to-[#161E2E]',
    glowColor: 'rgba(227,10,123,0.3)',
    title: 'Dominando Signal Forms',
    description:
      'Aprenda a modelar formulários com Signals, criar schemas tipados, validar regras de negócio e construir componentes e experiências reais com Angular.',
    url: '/cursos/dominando-signal-forms',
    level: 'intermediate',
    price: prices.signalForms.subscription.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2026, 8, 1),
  },
  {
    iconUrl: '/images/tech-icons/form-white.svg',
    iconAlt: 'Ícone Formulários',
    gradientClass: 'from-[#E30A7B]/25 via-[#6657EC]/20 to-[#161E2E]',
    glowColor: 'rgba(227,10,123,0.3)',
    title: 'Formulários com Angular',
    description:
      'Domine a criação de formulários no Angular 21+, usando Template Driven, Reactive Forms e Signal Forms.',
    url: '/cursos/formularios-com-angular',
    level: 'intermediate',
    price: prices.formulariosComAngular.subscription.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2026, 5, 1),
  },
  {
    iconUrl: '/images/tech-icons/angular-white.svg',
    iconAlt: 'Ícone Angular',
    gradientClass: 'from-[#DD0031]/30 via-[#E30A7B]/20 to-[#161E2E]',
    glowColor: 'rgba(221,0,49,0.3)',
    title: 'Introdução ao Angular',
    description:
      'Pare de perder tempo com tutoriais desatualizados. Aprenda Angular moderno desde o início, com a base sólida que as empresas realmente procuram.',
    url: '/cursos/introducao-ao-angular',
    level: 'beginner',
    price: prices.introducaoAoAngular.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2025),
  },
  {
    iconUrl: '/images/tech-icons/angular-white.svg',
    iconAlt: 'Ícone Angular',
    gradientClass: 'from-[#E30A7B]/30 via-[#6657EC]/25 to-[#161E2E]',
    glowColor: 'rgba(102,87,236,0.3)',
    title: 'Angular Moderno',
    description:
      'Aprenda todas as novidades do Angular 20 e se torne um desenvolvedor mais produtivo e eficiente no seu dia a dia!',
    url: '/cursos/angular-moderno',
    level: 'intermediate',
    price: prices.angularModerno.subscription.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2025),
  },
  {
    iconUrl: '/images/tech-icons/chemistry-flask-white.svg',
    iconAlt: 'Ícone Experimento Químico de Testes',
    gradientClass: 'from-[#99425B]/35 via-[#C21325]/20 to-[#161E2E]',
    glowColor: 'rgba(194,19,37,0.3)',
    title: 'Testes Automatizados com Angular',
    description:
      'Aprenda a criar testes eficientes de verdade e torne-se um profissional altamente requisitado no mercado!',
    url: '/cursos/testes-automatizados',
    level: 'advanced',
    price: prices.testesAutomatizadosComAngular.subscription.totalValue,
    status: CourseStatus.Ready,
    releaseDate: new Date(2024),
  },
  {
    iconUrl: '/images/tech-icons/angular-white.svg',
    iconAlt: 'Ícone Angular',
    gradientClass: 'from-[#FF3E00]/25 via-[#E30A7B]/20 to-[#161E2E]',
    glowColor: 'rgba(255,62,0,0.3)',
    badgeClass: 'badge-accent badge-outline',
    badgeText: 'Gratuito',
    title: 'Curso de Angular 17',
    description:
      'Construa uma aplicação para gerenciar produtos e aprenda conceitos fundamentais amplamente usados pelo mercado.',
    url: 'https://www.youtube.com/playlist?list=PLXEUJjGpEX7zwdFSAzIPiSf9p0tOeI1Yu',
    level: 'beginner',
    price: 0,
    status: CourseStatus.Ready,
    releaseDate: new Date(2023),
  },
];
